/**
 * Zentrale Service-Registry (Singleton Pattern).
 *
 * Services registrieren sich selbst über ihre register.js Dateien.
 * Diese Registry hält nur die Referenzen, kennt aber keine Services im Voraus.
 *
 * Vorteile:
 * - Services sind vollständig self-contained
 * - Löschen eines Service-Ordners = Service ist komplett weg
 * - Keine Änderungen an zentralen Dateien nötig
 */
class ServiceRegistry {
	constructor() {
		this.servicesWithConsent = [];
		this.servicesWithoutConsent = [];
		this.initFunctions = new Map();
	}

	/**
	 * Registriert einen Service.
	 *
	 * @param {Object} config - Service-Registrierungs-Konfiguration
	 * @param {string} config.name - Name des Services (z.B. "ThaliaChat")
	 * @param {Function} config.initFunction - Init-Funktion des Services
	 * @param {boolean} config.requiresConsent - true = Usercentrics-Consent nötig, false = ohne Consent
	 * @param {Array} config.configs - Array mit Config-Objekten (data-integ.js, data-prod.js, etc.)
	 *
	 * Beispiel:
	 * serviceRegistry.registerService({
	 *   name: "ThaliaChat",
	 *   initFunction: initThaliaChat,
	 *   requiresConsent: false,
	 *   configs: [thaliaChatInteg, thaliaChatProd]
	 * });
	 */
	registerService(config) {
		const { name, initFunction, requiresConsent, configs } = config;

		if (!name || !initFunction || !configs) {
			console.error("ServiceRegistry: Invalid service registration", config);
			return;
		}

		// Init-Funktion speichern
		this.initFunctions.set(name, initFunction);

		// Configs in die richtige Liste einsortieren
		if (requiresConsent) {
			this.servicesWithConsent.push(...configs);
		} else {
			this.servicesWithoutConsent.push(...configs);
		}

	}

	/**
	 * Gibt die Init-Funktion für einen Service zurück.
	 *
	 * @param {string} name - Name des Services
	 * @returns {Function|undefined} Init-Funktion oder undefined
	 */
	getInitFunction(name) {
		return this.initFunctions.get(name);
	}

	/**
	 * Gibt alle Services zurück, die Usercentrics-Consent benötigen.
	 *
	 * @returns {Array} Array mit Service-Konfigurationen
	 */
	getServicesWithConsent() {
		return this.servicesWithConsent;
	}

	/**
	 * Gibt alle Services zurück, die KEINEN Consent benötigen.
	 *
	 * @returns {Array} Array mit Service-Konfigurationen
	 */
	getServicesWithoutConsent() {
		return this.servicesWithoutConsent;
	}
}

// Singleton-Instanz exportieren
export default new ServiceRegistry();
